import DefaultCRUD from '../../utils'
const resource = `/user/user`;

const { get } = DefaultCRUD(resource)

export default {
  get,
}
